import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'cleanTranslate'
})

export class cleanTranslatePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {

    let lang = window['appGlobals'].constants.translations;

    let tmp = document.createElement("DIV");
    tmp.innerHTML = value;
    // let needle = tmp.textContent || tmp.innerText || "";

    let text = this.extractFirstText(tmp.innerHTML);

    for( let f in lang){

             if(f.trim().toLowerCase() === text.trim().toLowerCase()){
            return value.replace(text,lang[f])
             }
    }
    return value

  }

  extractFirstText(html) {
    let match = html.match(/>([^<]+)/);

    return match ? match[1].trim() : "";
  }


  replaceNonHTMLText(str, replacement) {
    return str.replace(/>([^<]*)</g, (match, text) => `>${replacement}<`);
  }

}



